var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { PreventableEvent } from './preventable-event';
// tslint:disable:max-line-length
/**
 * Arguments for the `seriesHover` event.
 */
var SeriesHoverEvent = /** @class */ (function (_super) {
    __extends(SeriesHoverEvent, _super);
    /**
     * @hidden
     */
    function SeriesHoverEvent(e, target) {
        var _this = _super.call(this, target) || this;
        _this.category = e.category;
        _this.categoryPoints = e.categoryPoints;
        _this.dataItem = e.dataItem;
        _this.nativeEvent = e.originalEvent;
        _this.percentage = e.percentage;
        _this.point = e.point;
        _this.series = e.series;
        _this.stackValue = e.stackValue;
        _this.value = e.value;
        return _this;
    }
    return SeriesHoverEvent;
}(PreventableEvent));
export { SeriesHoverEvent };
// tslint:enable:max-line-length
//# sourceMappingURL=series-hover-event.js.map